import { action, makeObservable, observable } from "mobx";

export interface IThirdPartySoftwareStore {
    list: ThirdPartySoftware[];
    isOpen: boolean;
    toggle(): void;
}
export class ThirdPartySoftwareStore implements IThirdPartySoftwareStore {
    constructor() {
        makeObservable(this);

        /* 
            This list is also available in POW3.UI (Layout.cshtml)
            If changes are made here, please update the list in POW3 as wel
            in future, the POW3 list should be removed.
        */
        this.list = [
            new ThirdPartySoftware("Active Reports", "Commercial License"),
            new ThirdPartySoftware("Spryng API", "Commercial License"),
            new ThirdPartySoftware("Clickatell API", "Commercial License"),
            new ThirdPartySoftware("CM API", "Commercial License"),
            new ThirdPartySoftware("Soluno API", "Commercial License"),
            new ThirdPartySoftware("PSWinCom", "MIT License"),
            new ThirdPartySoftware("Target365", "Commercial License"),
            new ThirdPartySoftware("Payex", "Commercial License"),
            new ThirdPartySoftware("TinyMCE", "GNU Lesser General Public License"),
            new ThirdPartySoftware("RSDK", "Commercial License"),
            new ThirdPartySoftware("Dragon Medical Speechkit", "Commercial License"),
            new ThirdPartySoftware("Rabbit MQ", "Mozilla Public License Version 2.0"),
            new ThirdPartySoftware("Redis.io", "Three Clause BSD License"),
            new ThirdPartySoftware("MsBuild", "MIT License"),
            new ThirdPartySoftware(".NET Core", "MIT License"),
            new ThirdPartySoftware(".NET Framework", "Microsoft Software License"),
            new ThirdPartySoftware("Fellow Oak", "Microsoft Public License"),
            new ThirdPartySoftware("Windows SDK", "Microsoft Software License"),
            new ThirdPartySoftware("C++ Redistributables", "Microsoft Software License"),
            new ThirdPartySoftware("NuGet Packages", "MIT License"),
            new ThirdPartySoftware("NPM Packages", "Artistic License 2.0"),
            new ThirdPartySoftware("Electron", "MIT License"),
        ];
    }

    public list: ThirdPartySoftware[];

    @observable
    public isOpen = false;

    @action
    public toggle(): void {
        this.isOpen = !this.isOpen;
    }
}

export class ThirdPartySoftware {
    constructor(
        public name: string,
        public license: string,
    ) {}
}
